'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const States = {

    async getForCountryID(countryID) {
		try {
            let response = await axios.get(API_URL + '/states/' + countryID, await getHeader());

			return response.data;

		} catch(error) {
            return false;
		}
	}
    
}

export default States;